/**
 * React Query hook for geofence data in ONE.
 */

import { useQuery } from '@tanstack/react-query';
import { getSiteGeofences, type SiteGeoFence } from '../services/geofence';

export function useSiteGeofences() {
  return useQuery<SiteGeoFence[]>({
    queryKey: ['site-geofences'],
    queryFn: getSiteGeofences,
    staleTime: 60_000,
    refetchInterval: 300_000, // Refresh every 5 minutes
  });
}
